module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main page-border"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_vm._v(_vm._s(_vm.currentPage === 'admin' ? 'Admin' : 'Reseller'))]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams")
    }
  }, [_vm._v("Manage Team")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v(" " + _vm._s((_vm.team) ? _vm.team.name : '') + " ")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t('action.editInfo')))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.isLoading || !_vm.team) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "card-text"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 card-stat"
  }, [_c('loading-indicator')], 1)]), _vm._v(" "), _c('p')])]) : _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('menu.general')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitGeneral($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGeneralAlert),
      expression: "showGeneralAlert"
    }],
    attrs: {
      "alertClass": "m-b-25 alert-dismissible",
      "type": ("" + ((_vm.successGeneralResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successGeneralResponse) ? 'md-check' : 'md-close'))
    }
  }, [(_vm.successGeneralResponse) ? _c('span', [_vm._v(_vm._s(_vm.successGeneralResponse))]) : (_vm.errorGeneralResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorGeneralResponse))]) : _vm._e()]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "team"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.displayName.labels')))]), _vm._v(" "), _c('span', {
    staticClass: "guideline-block"
  }, [_vm._v(_vm._s(_vm.$t('team.displayName.textGuide')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.team.name),
      expression: "team.name"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": _vm.$t('team.displayName.labels')
    },
    domProps: {
      "value": _vm._s(_vm.team.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.team.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.url.labels')))]), _vm._v(" "), _c('span', {
    staticClass: "help-block m-t-0"
  }, [_vm._v(_vm._s(_vm.$t('team.url.textGuide')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.team.namespace),
      expression: "team.namespace"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "namespace",
      "placeholder": _vm.$t('team.url.labels'),
      "disabled": "true"
    },
    domProps: {
      "value": _vm._s(_vm.team.namespace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.team.namespace = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.action.submit')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [(_vm.currentPage === 'admin') ? _c('team-terminate', {
    attrs: {
      "team": _vm.team
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('p')]), _vm._v(" "), (_vm.currentPage === 'admin') ? _c('div', {
    staticClass: "card-block"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("\n          Suspension policy\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSuspendStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuspendAlert),
      expression: "showSuspendAlert"
    }],
    attrs: {
      "alertClass": "m-b-25 alert-dismissible",
      "type": ("" + ((_vm.successSuspendResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successSuspendResponse) ? 'md-check' : 'md-close'))
    }
  }, [(_vm.successSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.successSuspendResponse))]) : (_vm.errorSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorSuspendResponse))]) : _vm._e()]), _vm._v(" "), _c('form-group', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Mode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSuspendMode),
      expression: "currentSuspendMode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.currentSuspendMode = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Auto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "suspend"
    }
  }, [_vm._v("Suspend")])])]), _vm._v(" "), (_vm.currentSuspendMode === 'suspend') ? _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('suspend_reason')
    }
  }, [_c('label', {
    attrs: {
      "for": "reason"
    }
  }, [_vm._v("Reason to client"), _c('span', {
    staticClass: "red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamSuspend.suspend_reason),
      expression: "teamSuspend.suspend_reason"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.teamSuspend.suspend_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.teamSuspend.suspend_reason = $event.target.value
      }
    }
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Submit "), _c('span', {
    staticClass: "glyphicon"
  })])]), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('team-transfer', {
    attrs: {
      "team": _vm.team
    }
  }), _vm._v(" "), _c('members-browser', {
    attrs: {
      "team": _vm.team
    },
    on: {
      "loadChanged": _vm.membersBrowserLoadChanged
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e884db94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/teams/TeamEditor.vue
// module id = 564
// module chunks = 1